import { useCallback, useEffect, useRef } from "react";
import useDataRef from "./useDataRef";
import useLazyRef from "./useLazyRef";

/**
 * @param {ResizeObserverCallback} callback
 * @param {ResizeObserverOptions} options
 */
export function useResizeObserver(callback, nodes = [], options) {
  const dataRef = useDataRef({ callback, options });

  const observer = useLazyRef(
    () =>
      new ResizeObserver((entries, observer) => {
        if (dataRef.current.callback) {
          dataRef.current.callback(entries, observer);
        }
      })
  ).current;

  useEffect(() => {
    const hasNodes = Array.isArray(nodes) && nodes?.length;
    if (hasNodes) {
      nodes.forEach((node) => {
        if (node) {
          observer.observe(node, dataRef.current.options);
        }
      });
      return () => {
        if (hasNodes) {
          observer.disconnect();
        }
      };
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataRef, observer, ...nodes]);

  return observer;
}

export default useResizeObserver;
